var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.688 10.528c0 .256.032.48.032.736 0 7.232-5.568 15.616-15.712 15.616-3.104 0-6.016-.896-8.448-2.464.448.032.864.064 1.312.064 2.592 0 4.96-.864 6.848-2.336-2.4-.064-4.448-1.632-5.152-3.808.352.064.704.096 1.056.096.48 0 .992-.064 1.44-.192a5.524 5.524 0 01-4.416-5.408v-.064c.736.416 1.6.672 2.496.704-1.472-.992-2.464-2.688-2.464-4.576 0-1.024.288-1.952.768-2.784 2.72 3.328 6.784 5.536 11.36 5.76a5.56 5.56 0 01-.16-1.248c0-3.04 2.464-5.504 5.536-5.504 1.568 0 3.008.672 4 1.728a11.6 11.6 0 003.52-1.312 5.404 5.404 0 01-2.432 3.008 10.56 10.56 0 003.168-.864 10.597 10.597 0 01-2.752 2.848"
  })));
}

export default SvgTwitter;